import gsap, { Power2, Power4 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from '../_app/cuchillo/utils/Ease';

export default class Preloader {
    _container;
    _images;
    _imagesWrapper;

    static currentIndex = 0;
    static lastTime = performance.now();
    static intervalTime = 280;
    static minInterval = 20;
    static speedFactor = 0.92;
    static loaded = false;

    static init() {
        this._container = GetBy.id('Preloader');
        // this._fakeFooter = GetBy.class('logo', this._container);

        // if (isDebug) {
        //     this._container.style.display = "none";
        //     return;
        // }

        this._images = GetBy.selector('img', this._container);
        gsap.set(this._images, { opacity: 0 });
        this._images[0].style.opacity = 1;
    }

    static update(__progress) { }

    static hide(__call) {
        // if (isDebug) {
        //     if (__call) __call();
        //     this._container.style.display = "none";
        //     return;
        // }

        let startGap = .2;   // separació inicial entre elements
        let endGap = 0.1;  // separació mínima final
        let totalDelay = 0;
        let n = this._images.length;

        for (let i = 0; i < n; i++) {
            const image = this._images[i];
            let call = () => { };

            let t = i / (n - 1);
            let gap = endGap + (startGap - endGap) * Math.pow(1 - t, 2);
            totalDelay += gap;

            if (i === this._images.length - 1) {
                call = () => {
                    gsap.to(this._container, {
                        // opacity: 0,
                        y: '-100%',
                        duration: 1,
                        delay: 1,
                        ease: Ease.EASE_CUCHILLO_IN_OUT,
                        onComplete: () => {
                            this._container.style.display = "none";
                            if (__call) __call();
                        }
                    });

                    // gsap.to(this._fakeFooter, { opacity: .2, duration: .5, delay: 1, filter: `blur(5px)` });
                }
            }

            gsap.set(image, {
                opacity: 1,
                delay: totalDelay,
                onComplete: () => {
                    call();
                }
            });
        }
    }
}
